module.exports = __webpack_public_path__ + "media/images/bus/conditions/PSOC-41f4f1e4310407bfbfafd039fbca95fb.svg";